import React from 'react';
import TooltipWithArrow from '../../common/TooltipWithArrow';
import { useTranslation } from 'react-i18next';

const SendMailTip = React.memo((): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <TooltipWithArrow
        id={'sendMailTip'}
        title={t('user.emailTip')}
        placement="right"
        config={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ],
        }}>
        <div id={'sendMailInfo'} className="ml-2" style={{ display: 'inline-block', cursor: 'pointer' }}>
          <i className="material-icons">info_outline</i>
        </div>
      </TooltipWithArrow>
    </>
  );
});

SendMailTip.displayName = 'SendMailTip';
export default SendMailTip;
